var _style, _rect, _g, _path, _path2, _rect2, _path3, _rect3, _rect4, _defs, _g2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftExcell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{opacity:0.12;}\n\t.st4{fill:#21A366;}\n\t.st5{fill:#33C481;}\n\t.st6{fill:#107C41;}\n\t.st7{fill:#185C37;}\n\t.st8{clip-path:url(#SVGID_2_);}\n\t.st9{opacity:0.48;}\n\t.st10{opacity:0.24;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    className: "st0",
    width: 512,
    height: 512
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Excel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_142"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ambient-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.3,48.3h311.2c10.8,0,19.6,8.8,19.6,19.6v376.2c0,10.8-8.8,19.6-19.6,19.6H152.3 c-10.8,0-19.6-8.8-19.6-19.6V67.9C132.7,56.9,141.5,48.3,152.3,48.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.3,48.3h311.2c10.8,0,19.6,8.8,19.6,19.6v376.2c0,10.8-8.8,19.6-19.6,19.6H152.3 c-10.8,0-19.6-8.8-19.6-19.6V67.9C132.7,56.9,141.5,48.3,152.3,48.3z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M314.3,48.5H153c-10.6-0.2-19.3,8.3-19.3,18.9l0,0v84.8h181.6L314.3,48.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M463.5,48.5H314.3v103.7h168.8V67.5C483,56.9,474.3,48.3,463.5,48.5L463.5,48.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 314.3,
    y: 255.8,
    className: "st6",
    width: 168.7,
    height: 103.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M314.3,359.7V255.8H132.7v188.3c-0.2,10.6,8.3,19.3,18.9,19.3l0,0h311.9c10.6,0.2,19.4-8.5,19.6-19.1v-84.6 L314.3,359.7L314.3,359.7z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 152,
    className: "st6",
    width: 181.8,
    height: 103.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 314.3,
    y: 152,
    className: "st4",
    width: 168.7,
    height: 103.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M152.3,48.3h311.2c10.8,0,19.6,8.8,19.6,19.6v376.2c0,10.8-8.8,19.6-19.6,19.6H152.3 c-10.8,0-19.6-8.8-19.6-19.6V67.9C132.7,56.9,141.5,48.3,152.3,48.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,139h194.4c10.8,0,19.6,8.8,19.6,19.6V353c0,10.8-8.8,19.6-19.6,19.6H48.5 c-10.8,0-19.6-8.8-19.6-19.6V158.6C28.8,147.8,37.7,139,48.5,139z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,139h194.4c10.8,0,19.6,8.8,19.6,19.6V353c0,10.8-8.8,19.6-19.6,19.6H48.5 c-10.8,0-19.6-8.8-19.6-19.6V158.6C28.8,147.8,37.7,139,48.5,139z"
  }))))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.5,139h194.4c10.8,0,19.6,8.8,19.6,19.6V353c0,10.8-8.8,19.6-19.6,19.6H48.5c-10.8,0-19.6-8.8-19.6-19.6 V158.6C28.8,147.8,37.7,139,48.5,139z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.1,319.2l40.9-63.4l-37.3-63.2H123l20.3,40.1c1.6,2.9,2.9,5.8,4,8.8l0,0c1.3-3.1,2.7-6.1,4.3-9l23-40.1 h27.7l-39.6,63.4l39.4,63.9h-29.5l-23-44.5c-1.3-1.8-2.2-3.8-3.1-5.8l0,0c-0.7,2-1.6,4-2.7,5.8l-24.5,44.5L89.1,319.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftExcell);
export default __webpack_public_path__ + "static/media/microsoft-excell.032ed85bd002b57fdc8205860081e8e6.svg";
export { ForwardRef as ReactComponent };